/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const articlesRoutes = {
  name: RouteName.Articles,
  path: "articles",
  component: () =>
    import("@follaw-fr/views/side_menu_views/SocialMediaArticlesView.vue"),
};
